import { QueryFunctionContext } from '@tanstack/react-query'
import anklePatrolAxios from '../../../services/config/axiosClient'
import { notificationsAPIRoutes } from './apiRoutes'
import { commonResponse } from '../../Auth/types/APIResponseType'
import { NotificationCount, NotificationList } from './types/APIResponseType'

interface NotificationOptions {
  onSuccess: () => void
  onError: (error: { message: string }) => void
}

export const notificationsList = ({
  queryKey,
}: QueryFunctionContext): Promise<commonResponse<NotificationList>> => {
  console.log({ queryKey })
  return anklePatrolAxios.get(
    `${notificationsAPIRoutes.notificationsList}?limit=${queryKey?.[2]}&page=${queryKey?.[1]}`,
  )
}

export const notificationCount = (): Promise<
  commonResponse<NotificationCount>
> => anklePatrolAxios.get(notificationsAPIRoutes.notificationCount)

export const notificationMarkRead = (
  options: NotificationOptions,
): Promise<commonResponse<null>> => {
  return anklePatrolAxios
    .put(notificationsAPIRoutes.notificationMarkRead)
    .then((response) => {
      options.onSuccess()
      return response.data
    })
    .catch((error) => {
      options.onError({ message: error.message })
      throw error
    })
}
